import React from 'react'
import Title from '../../../Components/Title/Title'
import style from './AboutBlock.module.css'
import { AboutBlockImg } from '../../../Assets/Images/Roofing/AboutBlock/Index'

const AboutBlock = () => {
    const features = ['WATERPROOF', 'WIND RESISTANT', 'WARP RESISTANT', 'DURABLE']

    return (
        <div className={style.about} id={'about'}>
            <div className={'customContainer'}>
                <Title title={'About Roofing'} />
                <div className={style.about_wrap}>
                    <div className={style.about_content}>
                        <p className={style.about_description}>
                            At XLeum Construction, we understand that a high-quality roof is
                            the first line of defense for your property. With over 19 years of
                            experience in the industry, our skilled team specializes in
                            delivering durable and reliable roofing solutions tailored to your
                            specific needs. Whether you are looking for the classic appeal of
                            shingles, the modern resilience of metal, or the energy-efficient
                            protection of TPO/EPDM, we provide expert craftsmanship to ensure
                            your investment is built to last.
                        </p>
                        <ul className={style.about_list}>
                            {features.map((feature, index) => (
                                <li key={index} className={style.about_list__item}>
                                    <svg
                                        className={style.about_list__img}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="16"
                                        viewBox="0 0 18 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M1 10.1667L6.71429 14.5L17 1.5"
                                            stroke="#FECB00"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <img src={AboutBlockImg} alt="About Roofing" className={style.about_img} />
                </div>
            </div>
        </div>
    )
}

export default AboutBlock
